(function () {
  const Core = window.RB.Core;
  const AX = (window.RB.AnimKit = window.RB.AnimKit || {});

  function setText(e, text) {
    const t = text === undefined || text === null ? "" : String(text);
    e.innerHTML = window.UIDOM.iconize(t.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"));
  }

  const DUR = {
    banner: 850, big: 1250, pop: 600, detonate: 700,
    arc: 780, tuck: 720, morph: 840, recycle: 620, spawn: 720,
    burn: 1180, burnFast: 560, burnRead: 380,
    shuffle: 1440, deal: 380, revealHold: 1320, collect: 340,
  };
  const STAG = { draw: 150, drawMany: 100, tuck: 90, deal: 100, collect: 100, burn: 120, move: 70 };
  const EASE = {
    peel: "cubic-bezier(.2,.8,.4,1)",
    arc: "cubic-bezier(.22,.61,.36,1)",
    apex: "cubic-bezier(.45,0,.55,1)",
    settle: "cubic-bezier(.34,1.32,.5,1)",
    flip: "cubic-bezier(.5,0,.3,1)",
    fall: "ease-in",
  };
  const SPAWN = {
    gold: { tint: "#f0c46a", core: "#fff6db", motes: 12, spin: 28, burst: 2.7 },
    token: { tint: "#8fc6ee", core: "#eaf5ff", motes: 8, spin: 12, burst: 2.2 },
  };
  const TOKEN_FLAVOR = { Gold: "gold" };
  const MIN_STEP_MS = 120;
  const MIN_WALL_MS = 34;
  const CINE_MAX_RATE = 4;

  const Anim = {
    speed: 1,
    budget: 0,
    _fit: 0,
    _rate: 1,
    queue: [],
    playing: false,
    onIdle: null,
    _timer: null,
    _gen: 0,
    _anims: [],
    _cleanup: [],
    hidden: {},
    _rects: {},
    _prev: {},
    _prevSlot: {},
    _placeholders: [],
    prevPiles: {},
    scoreHold: [0, 0],

    restorePlaceholders() {
      if (!this.available()) return;
      for (const ph of this._placeholders) mountPlaceholder(this, ph);
    },

    capture(prev, state) {
      this._rects = {};
      this._prev = {};
      this._prevSlot = {};
      this.prevPiles = {};
      if (prev) {
        for (let p = 0; p < 2; p++) {
          this.prevPiles["trash-" + p] = prev.players[p].trash.slice();
          this.prevPiles["banish-" + p] = prev.players[p].banish.slice();
        }
      }
      if (!this.available()) return;
      const seen = document.querySelectorAll("[data-iid],[data-fxkey]");
      for (let i = 0; i < seen.length; i++) {
        const e = seen[i];
        if (!e.getBoundingClientRect) continue;
        const r = measure(e);
        if (!r.width && !r.height) continue;
        const key = e.getAttribute("data-iid") || e.getAttribute("data-fxkey");
        this._prev[key] =
          { left: r.left, top: r.top, width: r.width, height: r.height, right: r.right, bottom: r.bottom };
        const host = e.parentNode && e.closest ? e.closest("[data-anchor]") : null;
        if (host && host !== e) {
          const path = [];
          let cur = e;
          while (cur && cur !== host) {
            path.unshift(Array.prototype.indexOf.call(cur.parentNode.children, cur));
            cur = cur.parentNode;
          }
          this._prevSlot[key] = { anchor: host.getAttribute("data-anchor"), path: path, clone: e.cloneNode(true) };
        }
      }
      if (!prev) return;
      for (let p = 0; p < 2; p++) {
        const now = {};
        for (const iid of state.players[p].hand) now[iid] = true;
        for (const iid of prev.players[p].hand) {
          if (now[iid]) continue;
          if (this._prev[iid]) this._rects[iid] = this._prev[iid];
        }
      }
    },

    available() {
      return typeof document !== "undefined" && !!document.body && !!document.querySelector;
    },

    flat() {
      if (typeof window === "undefined" || typeof window.matchMedia !== "function") return false;
      try { return window.matchMedia("(prefers-reduced-motion: reduce)").matches; } catch (e) { return false; }
    },

    idle() {
      return !this.playing;
    },

    layer() {
      let l = document.getElementById("fxlayer");
      if (!l) {
        l = document.createElement("div");
        l.id = "fxlayer";
        document.body.appendChild(l);
      }
      return l;
    },

    shownPoints(state, p) {
      return Math.max(0, state.players[p].points - (this.scoreHold[p] || 0));
    },

    landScore(p, n) {
      this.scoreHold[p] = Math.max(0, (this.scoreHold[p] || 0) - n);
    },

    revealAll() {
      const iids = Object.keys(this.hidden);
      this.hidden = {};
      this.scoreHold = [0, 0];
      if (!this.available()) return;
      for (const iid of iids) {
        const e = document.querySelector(AX.hiddenSelector(iid));
        if (e) { e.classList.remove("prearrive"); e.classList.add("arrive"); }
      }
    },

    reveal(iids) {
      for (const iid of iids || []) {
        delete this.hidden[iid];
        if (!this.available()) continue;
        const e = document.querySelector(AX.hiddenSelector(iid));
        if (e) { e.classList.remove("prearrive"); e.classList.add("arrive"); AX.arriveExtra(e); }
      }
    },

    flush() {
      this.queue = [];
      this._gen++;
      if (this._timer) { clearTimeout(this._timer); this._timer = null; }
      for (const a of this._anims) { try { a.cancel(); } catch (e) { } }
      this._anims = [];
      for (const fn of this._cleanup.slice()) { try { fn(); } catch (e) { } }
      this._cleanup = [];
      for (const ph of this._placeholders) { if (ph.ghost) { try { ph.ghost.remove(); } catch (e) { } } }
      this._placeholders = [];
      const l = document.getElementById("fxlayer");
      if (l) l.innerHTML = "";
      this._held = null;
      this._fit = 0;
      this.revealAll();
      const was = this.playing;
      this.playing = false;
      if (was && this.onIdle) this.onIdle();
    },

    notify(action, events, state, opts) {
      if (!this.available() || !this.speed) {
        if (this.onIdle) this.onIdle();
        return;
      }
      opts = opts || {};
      const arrivals = AX.diffArrivals(opts.prevState, state);
      let steps = AX.translate(action, events || [], state, opts, arrivals);
      if (this.speed > CINE_MAX_RATE || this.budget > 0) steps = steps.filter(function (s) { return s.kind !== "cine"; });
      for (const s of steps) holdPileArrivals(s);
      for (const s of steps) markHidden(this, s);
      for (const s of steps) if (s.kind === "score") this.scoreHold[s.player] += s.n || 1;
      placeholdDepartures(this, steps);
      if (!steps.length) {
        if (!this.playing && this.onIdle) this.onIdle();
        return;
      }
      const squeeze = steps.length > 12 ? 0.7 : 1;
      for (const s of steps) if (s.kind !== "cine") s.dur = Math.round(s.dur * squeeze);
      if (!this.playing) {
        let total = 0;
        for (const s of steps) total += Math.max(MIN_STEP_MS, s.dur || 0);
        this._fit = this.budget > 0 ? Math.max(1, total / this.budget) : 0;
        latch(this);
        reflow(this, firstArcDur(steps));
      }
      this.queue = this.queue.concat(steps);
      if (!this.playing) this._step();
    },

    _step() {
      const self = this;
      if (!this.queue.length) {
        this.playing = false;
        this._fit = 0;
        this.revealAll();
        if (this.dockHeld) this.dockHeld();
        if (this.onIdle) this.onIdle();
        return;
      }
      this.playing = true;
      const s = this.queue.shift();
      latch(this);
      let dur = Math.max(MIN_STEP_MS, Math.round(s.dur));
      if (this.flat()) dur = Math.min(dur, 220);
      dur = Math.max(dur, Math.round(MIN_WALL_MS * this._rate));
      const k = s.dur ? dur / s.dur : 1;
      const span = Math.round(dur / this._rate);
      let held = null;
      try { held = AX.runStep(s, dur, k); } catch (e) { logFx(e); }
      scheduleReveals(this, s, k, 0, dur);
      const gen = this._gen;
      const next = function () {
        if (self._gen !== gen) return;
        if (self._timer) { clearTimeout(self._timer); self._timer = null; }
        self._step();
      };
      if (held && typeof held.then === "function") {
        held.then(next, next);
        this._timer = setTimeout(next, span + AX.HOLD_SLACK);
        return;
      }
      this._timer = setTimeout(function () {
        self._timer = null;
        self._step();
      }, span);
    },
  };

  function latch(A) {
    const rate = A._fit || (A.speed > 0 ? A.speed : 1);
    if (rate === A._rate && A._fxk === rate) return;
    A._rate = rate;
    A._fxk = rate;
    if (A.available()) document.documentElement.style.setProperty("--fxk", String(1 / rate));
  }

  function later(fn, ms) {
    return setTimeout(fn, Math.max(0, ms || 0) / Anim._rate);
  }

  function wall(ms) {
    return Math.max(1, Math.round(ms / Anim._rate));
  }

  function placeholdDepartures(A, steps) {
    if (!A.available() || A.flat()) return;
    let first = true;
    const visit = function (s) {
      if (s.kind === "group") { for (const c of s.steps) visit(c); return; }
      const key = s.from && s.from.prevOf;
      const r = key ? A._prev[key] : null;
      if ((first && !s.slotHold) || !r || !s.card || !fitsCard(r)) return;
      if (document.querySelector(AX.hiddenSelector(key))) return;
      const ph = { key: key, step: s, rect: r, ghost: null };
      A._placeholders.push(ph);
      s.placeholder = ph;
      mountPlaceholder(A, ph);
    };
    for (const s of steps) { visit(s); first = false; }
  }

  function mountPlaceholder(A, ph) {
    if (ph.ghost) { try { ph.ghost.remove(); } catch (e) { } }
    ph.ghost = slotPlaceholder(A, ph.key) || pinnedPlaceholder(A, ph.step, ph.rect);
  }

  function dropPlaceholder(A, ph) {
    const i = A._placeholders.indexOf(ph);
    if (i >= 0) A._placeholders.splice(i, 1);
    if (ph.ghost) { try { ph.ghost.remove(); } catch (e) { } }
    ph.ghost = null;
  }

  function collapsePlaceholder(A, ph, dur, hold) {
    const ghost = ph.ghost;
    const i = A._placeholders.indexOf(ph);
    if (i >= 0) A._placeholders.splice(i, 1);
    ph.ghost = null;
    if (!ghost) return;
    ghost.style.visibility = "hidden";
    ghost.style.overflow = "hidden";
    const w = ghost.getBoundingClientRect().width;
    const shrink = Math.max(80, Math.round(dur * 0.3));
    play(ghost, [
      { width: w + "px", marginLeft: "0px", marginRight: "0px", borderWidth: "0px" },
      { width: "0px", marginLeft: "0px", marginRight: "0px", borderWidth: "0px" },
    ], { duration: shrink, delay: Math.round(dur * hold), easing: EASE.arc, fill: "forwards" });
    later(function () { try { ghost.remove(); } catch (e) { } }, Math.round(dur * hold) + shrink + 20);
  }

  function slotPlaceholder(A, key) {
    const slot = A._prevSlot[key];
    if (!slot) return null;
    let cur = document.querySelector("[data-anchor='" + slot.anchor + "']");
    for (let i = 0; cur && i < slot.path.length - 1; i++) cur = cur.children[slot.path[i]];
    if (!cur) return null;
    const ghost = slot.clone.cloneNode(true);
    ghost.removeAttribute("data-iid");
    ghost.removeAttribute("data-fxkey");
    ghost.setAttribute("data-fxghost", key);
    ghost.classList.add("fxslotghost");
    const at = Math.min(slot.path[slot.path.length - 1], cur.children.length);
    cur.insertBefore(ghost, cur.children[at] || null);
    return ghost;
  }

  function pinnedPlaceholder(A, s, r) {
    const ghost = AX.buildCard({ card: s.card, crop: s.crop || "full" }, r.width, r.height).box;
    ghost.classList.add("fxplaceholder");
    ghost.style.left = r.left + "px";
    ghost.style.top = r.top + "px";
    A.layer().appendChild(ghost);
    return ghost;
  }

  function pileAnchorOf(spec) {
    const a = spec && spec.anchor;
    return a && (a.indexOf("trash-") === 0 || a.indexOf("banish-") === 0) ? a : null;
  }

  function holdPileArrivals(s) {
    if (s.kind === "group") { for (const c of s.steps) holdPileArrivals(c); return; }
    if (s.kind !== "arc" && s.kind !== "retire" && s.kind !== "detonate") return;
    const a = pileAnchorOf(s.to);
    if (!a) return;
    const key = "@pile-" + a;
    s.reveal = (s.reveal || []).concat([key]);
    if (s.revealAt === undefined) s.revealAt = s.kind === "detonate" ? AX.BLAST_AT : 0.94;
  }

  function markHidden(A, s) {
    if (s.kind === "group") {
      for (const c of s.steps) markHidden(A, c);
      return;
    }
    for (const iid of s.reveal || []) {
      A.hidden[iid] = true;
      const e = document.querySelector(AX.hiddenSelector(iid));
      if (e) e.classList.add("prearrive");
    }
  }

  function scheduleReveals(A, s, k, base, total) {
    if (s.kind === "group") {
      for (const c of s.steps) scheduleReveals(A, c, k, base + (c.delay || 0) * k, total);
      return;
    }
    if (!s.reveal || !s.reveal.length) return;
    const own = s.dur ? s.dur * k : total;
    const at = Math.max(0, Math.min(total, base + own * (s.revealAt === undefined ? 0.98 : s.revealAt)));
    const gen = A._gen;
    later(function () { if (A._gen === gen) A.reveal(s.reveal); }, Math.round(at));
  }

  function firstArcDur(steps) {
    for (const s of steps) {
      if (s.kind === "arc" || s.kind === "morph" || s.kind === "spawn") return s.dur;
      if (s.kind === "group") {
        for (const c of s.steps) if (c.kind === "arc" || c.kind === "morph" || c.kind === "spawn") return c.dur;
      }
    }
    return DUR.arc;
  }

  function logFx(e) {
    if (typeof console !== "undefined" && console.error) console.error("[anim]", e);
  }

  function play(el, frames, opts) {
    return playAt(el, frames, opts, Anim._rate);
  }

  function playRaw(el, frames, opts) {
    return playAt(el, frames, opts, 1);
  }

  function playAt(el, frames, opts, rate) {
    if (!el || typeof el.animate !== "function") return null;
    try {
      const a = el.animate(frames, opts);
      if (rate !== 1) a.playbackRate = rate;
      Anim._anims.push(a);
      a.onfinish = function () {
        const i = Anim._anims.indexOf(a);
        if (i >= 0) Anim._anims.splice(i, 1);
      };
      return a;
    } catch (e) { return null; }
  }

  function anchorEl(spec) {
    let e = null;
    if (spec && spec.iid) e = document.querySelector("[data-iid='" + spec.iid + "']");
    if (!e && spec && spec.fxkey) e = document.querySelector("[data-fxkey='" + spec.fxkey + "']");
    if (!e && spec && spec.anchor) e = document.querySelector("[data-anchor='" + spec.anchor + "']");
    if (!e && spec && spec.fallback) e = document.querySelector("[data-anchor='" + spec.fallback + "']");
    if (e && spec && spec.pick) {
      const inner = e.querySelector(spec.pick);
      if (inner) return inner;
    }
    return e;
  }

  function measure(e) {
    const r = e.getBoundingClientRect();
    if (!(r.width || r.height) || !e.offsetWidth || !e.closest) return r;
    const arena = e.closest("#arena");
    if (!arena) return r;
    const s = parseFloat(getComputedStyle(arena).getPropertyValue("--s")) || 1;
    const w = e.offsetWidth * s;
    const h = e.offsetHeight * s;
    if (Math.abs(w - r.width) < 1 && Math.abs(h - r.height) < 1) return r;
    const cx = r.left + r.width / 2;
    const cy = r.top + r.height / 2;
    return { left: cx - w / 2, top: cy - h / 2, width: w, height: h, right: cx + w / 2, bottom: cy + h / 2 };
  }

  function anchorRect(spec) {
    if (spec && spec.rectOf && Anim._rects[spec.rectOf]) return Anim._rects[spec.rectOf];
    if (spec && spec.prevOf && Anim._prev[spec.prevOf]) return Anim._prev[spec.prevOf];
    const e = anchorEl(spec);
    if (e && e.getBoundingClientRect) {
      const r = measure(e);
      if (r.width || r.height) return r;
    }
    return null;
  }

  function pileOf(spec) {
    const e = anchorEl(spec);
    if (!e || !e.querySelector) return null;
    return e.querySelector(".pilestack") || e.querySelector(".runedeckpile");
  }

  function centerOf(r) {
    return { x: r.left + r.width / 2, y: r.top + r.height / 2 };
  }

  function clamp(v, lo, hi) {
    return v < lo ? lo : v > hi ? hi : v;
  }

  function fitsCard(r) {
    if (!r || !(r.width > 18) || !(r.width < 260) || !(r.height > 18) || !(r.height < 320)) return false;
    const aspect = r.width / r.height;
    return aspect > 0.4 && aspect < 1.15;
  }

  function tf(x, y, rot, sc) {
    return "translate(" + x + "px," + y + "px) rotate(" + rot + "deg) scale(" + sc + ")";
  }

  function reflow(A, cardDur) {
    if (!A.available()) return;
    const wait = A.flat() ? 0 : Math.round(cardDur * 0.3);
    const slide = A.flat() ? 120 : Math.round(cardDur * 0.34);
    for (const iid in A._prev) {
      const e = document.querySelector("[data-iid='" + iid + "']");
      if (!e || !e.getBoundingClientRect) continue;
      if (e.classList.contains("prearrive")) continue;
      if (!e.closest || !e.closest(".handfan")) continue;
      const r = e.getBoundingClientRect();
      if (!r.width && !r.height) continue;
      const dx = A._prev[iid].left - r.left;
      const dy = A._prev[iid].top - r.top;
      if (Math.abs(dx) < 1.5 && Math.abs(dy) < 1.5) continue;
      play(e, [
        { transform: "translate(" + dx + "px," + dy + "px)" },
        { transform: "none" },
      ], { duration: slide, delay: wait, easing: EASE.arc, fill: "backwards" });
    }
  }

  function peelPile(stack, ms) {
    if (!stack) return;
    const top = stack.lastElementChild;
    if (!top || top.classList.contains("rdcount")) return;
    play(top, [
      { transform: "translate(0,0) rotate(0deg)", easing: EASE.peel },
      { transform: "translate(3px,-6px) rotate(-3.5deg)", offset: 0.45, easing: EASE.fall },
      { transform: "translate(0,0) rotate(0deg)" },
    ], { duration: Math.max(140, ms) });
  }

  function bumpPile(stack, delay) {
    if (!stack) return;
    stack.style.transformOrigin = "50% 100%";
    play(stack, [
      { transform: "scaleY(1) translateY(0)", easing: EASE.settle },
      { transform: "scaleY(.95) translateY(3px)", offset: 0.36, easing: EASE.settle },
      { transform: "scaleY(1) translateY(0)" },
    ], { duration: 260, delay: Math.max(0, delay), fill: "backwards" });
  }

  function tickPlate(host, delay, cls) {
    const p = host && host.querySelector ? host.querySelector(".slotplate") : null;
    if (!p) return;
    const gen = Anim._gen;
    later(function () {
      if (Anim._gen !== gen || !p.parentNode) return;
      p.classList.add("fxtick");
      if (cls) p.classList.add(cls);
      later(function () { p.classList.remove("fxtick"); if (cls) p.classList.remove(cls); }, 420);
    }, Math.max(0, delay));
  }

  function overlay(cls, ttl, build) {
    const node = document.createElement("div");
    node.className = cls;
    if (build) build(node);
    Anim.layer().appendChild(node);
    later(function () { node.remove(); }, ttl);
    return node;
  }

  Object.assign(AX, { overlay: overlay, HOLD_SLACK: 20000, setText: setText, DUR: DUR, STAG: STAG, EASE: EASE, SPAWN: SPAWN, TOKEN_FLAVOR: TOKEN_FLAVOR, Anim: Anim, dropPlaceholder: dropPlaceholder, collapsePlaceholder: collapsePlaceholder, logFx: logFx, play: play, playRaw: playRaw, later: later, wall: wall, anchorEl: anchorEl, anchorRect: anchorRect, pileOf: pileOf, centerOf: centerOf, clamp: clamp, fitsCard: fitsCard, tf: tf, peelPile: peelPile, bumpPile: bumpPile, tickPlate: tickPlate });
  window.RB = window.RB || {};
  window.RB.Anim = Anim;
})();
